import React from "react";
import { Layout } from "../components/Layout";
import { useLanguage } from "../context/LanguageContext";
import { siteContent } from "../mock/rosablu.mock";
import { Card } from "../components/ui/card";
import { MapPin } from "lucide-react";

export default function LocationPage() {
  const { lang } = useLanguage();
  const loc = siteContent.location[lang];

  return (
    <Layout>
      <section className="bg-[#f6f0ea] py-14 md:py-18">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="grid gap-8 md:grid-cols-[1.3fr,1fr]">
            <div>
              <h1 className="font-serif text-2xl text-slate-900 md:text-3xl">
                {loc.title}
              </h1>
              <p className="mt-2 text-sm leading-relaxed text-slate-700 md:text-base">
                {loc.subtitle}
              </p>
              <ul className="mt-4 grid gap-2 text-sm text-slate-700 md:grid-cols-2">
                {loc.highlights.map((item) => (
                  <li key={item} className="flex items-center gap-2">
                    <MapPin className="h-4 w-4 text-[#b07157]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <Card className="rounded-3xl border-dashed border-slate-300 bg-white/80 p-6 text-sm text-slate-600 shadow-sm backdrop-blur-md">
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">
                MAPPA
              </p>
              <p className="mt-2">
                {lang === "it"
                  ? "Qui inseriremo una mappa interattiva (es. Google Maps) per mostrare con precisione la posizione dell'appartamento."
                  : "Here we will add an interactive map (e.g. Google Maps) to show the exact location of the apartment."}
              </p>
              <p className="mt-4 text-xs text-slate-500">
                Via del Zicol, 4 · 38020 Piano di Commezzadura (TN)
              </p>
            </Card>
          </div>
        </div>
      </section>
    </Layout>
  );
}
